<button ap-tooltip="<kbd><kbd>alt</kbd> + <kbd>s</kbd></kbd>" (click)="loadFilters();" class="btn btn-default" attr.aria-label="{{ 'FILTERS.FILTER.ACTIONS.LOAD' | translate}}"><i class="fa fa-filter" alt="filter"></i></button>
